import { HttpErrorResponse } from '@angular/common/http';
import { Component, NgZone } from '@angular/core';
import { LoginService } from '../login/service/login.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as CryptoJS from 'crypto-js';

export const ALLOWED_ORIGINS = [
  'https://demo.aiagent.canstringai.com',
  'https://aiagentcall.canstringai.com',
  'http://localhost:4200' // Local development
];

@Component({
  selector: 'app-auto-login',
  templateUrl: './auto-login.component.html',
  styleUrl: './auto-login.component.scss'
})
export class AutoLoginComponent {
  bodySpinner:boolean = true;
  secret_key:any;
  email:any;
  dataPayload:any;
   senderOrigin: string = '';
  constructor(private loginService:LoginService,private router:Router,private route:ActivatedRoute,private ngZone: NgZone){
 localStorage.clear();
    sessionStorage.clear();
  }

  ngOnInit(){

      if (!window.opener) return;

    // 1. Alert the opening window that we are ready. 
    // If you don't know the specific domain yet, you can use '*' for this initial ping,
    // but the sender MUST validate your origin when responding.
    window.opener.postMessage('angular-app-ready', '*');

    // 2. Bind the listener to a named function so we can clean it up later
    window.addEventListener('message', this.handleMessage);
  }
  

private handleMessage = (event: MessageEvent) => {
    // 🛡️ SECURITY CHECK: Match against the whitelist array
    if (!ALLOWED_ORIGINS.includes(event.origin)) {
      console.warn('Rejected message from unauthorized origin:', event.origin);
      return; 
    }

    if (event.data?.type === 'HIDDEN_PARAMS') {
      this.ngZone.run(() => {
        this.senderOrigin = event.origin;
        this.dataPayload = event.data.payload;
        console.log(`Secure payload received from ${event.origin}:`, this.dataPayload);
        this.autologin(this.dataPayload);
      });
    }
  };

  ngOnDestroy() {
    // Prevent memory leaks when component unmounts
    window.removeEventListener('message', this.handleMessage);
  }
    

 
autologin(payload:any){
    this.loginService.singleSignOn(payload).subscribe({
     next:(result:any)=>{
       localStorage.setItem(
                  'loginuser',
                  payload?.email
                );
                sessionStorage.setItem('token', result['token']);
                this.loginService.getUser().subscribe({next:(response:any)=>{
                    var data = CryptoJS.AES.encrypt(JSON.stringify(response),this.loginService.enCryptKey);
                    localStorage.setItem("user",data.toString());
                     this.loginService.isAuthorizedUser=true;
                    // this.showComp.emit({ make: true, name: 'login' });
                      this.router.navigateByUrl("dashboard");
                     this.bodySpinner=false;
                },error:(error:HttpErrorResponse)=>{
                }});
     },
     error:(errors:HttpErrorResponse)=>{}
    });
}


}
